import { editor } from "monaco-editor/esm/vs/editor/editor.api";
import { useEffect, useState } from "react";
import { CodeEditorViewState } from "../../../types/CodeEditor";
import { CodeEditorService, ViewMode } from "../services/CodeEditorService";

export const useEditorViewState = (codeEditor?: editor.ICodeEditor, filePath?: string) => {
  const [viewMode, setViewMode] = useState<ViewMode>("blank");
  const [editorViewState, setEditorViewState] = useState<CodeEditorViewState>({});

  useEffect(() => {
    if (!codeEditor || !filePath) {
      setViewMode("blank");
      return;
    }

    // save current editor view state
    const currentModel = codeEditor.getModel();
    if (currentModel) {
      setEditorViewState({ ...editorViewState, [currentModel.uri.path]: codeEditor.saveViewState() });
    }

    // open a file for viewing
    const result = CodeEditorService.openFileInEditor(codeEditor, filePath);
    setViewMode(result);

    // restore previously saved editor view state, if available
    if (result === "code" && editorViewState[filePath]) {
      codeEditor.restoreViewState(editorViewState[filePath])
    }

  }, [codeEditor, filePath])

  return viewMode;
}
